import React, { FC } from 'react';
import IncentiveListingPage, { incentiveFilterKeys } from './List/IncentiveListingPage';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import PruRoute from '../../../common/components/PruRoute';
import { INCENTIVE_BASE_PATH } from '../constants';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../common/constants';
import IncentiveDetailPage from './Create/IncentiveDetailPage';
import ParamsProvider from '../../../common/components/ParamsProvider';

const IncentiveRoutes: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Redirect exact from={`${INCENTIVE_BASE_PATH}`} to={`${INCENTIVE_BASE_PATH}/list`} />
      <PruRoute exact path={`${INCENTIVE_BASE_PATH}/list`} render={(props) => (
        <ParamsProvider {...props} acceptKeys={incentiveFilterKeys}>
          <IncentiveListingPage/>
        </ParamsProvider>
      )}/>
      <PruRoute exact path={`${INCENTIVE_BASE_PATH}/edit/:id`} component={IncentiveDetailPage}/>
      <PruRoute exact path={`${INCENTIVE_BASE_PATH}/create`} component={IncentiveDetailPage}/>
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  )
};

export default IncentiveRoutes;